import { render, staticRenderFns } from "./FormRequest.vue?vue&type=template&id=4669f54e"
import script from "./FormRequest.vue?vue&type=script&lang=js"
export * from "./FormRequest.vue?vue&type=script&lang=js"
import style0 from "./FormRequest.vue?vue&type=style&index=0&id=4669f54e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports